<template>
	<Loader v-if="loading" />
	<div v-else class="content">
		<h1>Cronjob performance</h1>

		<Tabs
			:tabs="tabs"
			v-model="active_tab"
			class="margin-top" />

		<!-- Tab: Overview -->
		<div
			class="margin-top"
			v-show="active_tab == 'overview'">

			<table>
				<thead>
					<tr>
						<th></th>
						<th
							style="text-align: center;"
							colspan="3"
							v-for="day in dayList">{{ !day ? 'Today' : (day == 1 ? 'Yesterday' : 'Last ' + day + ' days') }}</th>
					</tr>
				</thead>
				<thead>
					<tr>
						<th></th>
						<template v-for="day in dayList">
							<th style="text-align: center;">Avg.</th>
							<th style="text-align: center;">Max.</th>
							<th style="text-align: center;">Min.</th>
						</template>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(server, i) in records">
						<td>{{ server.worker ? server.worker.name : 'Master' }}</td>
						<template v-for="day in dayList">
							<td style="text-align: center; border-left: 1px solid #ccc">
								<div v-bind:class="{
									red: server.statistics.times[day].avg > threshold,
								}">
									{{ server.statistics.times[day].avg ? server.statistics.times[day].avg : '-' }}
								</div>
							</td>
							<td style="text-align: center;">
								<div v-bind:class="{
									red: server.statistics.times[day].max > threshold,
								}">
									{{ server.statistics.times[day].max ? server.statistics.times[day].max : '-' }}
								</div>
							</td>
							<td style="text-align: center;">
								{{ server.statistics.times[day].min ? server.statistics.times[day].min : '-' }}
							</td>
						</template>
					</tr>
				</tbody>
			</table>

		</div>

		<!-- Tabs: Servers -->
		<div
			v-for="(server, i) in records"
			v-if="active_tab == 't-' + i">
			<Table
				:ref="'table-' + String(i)"
				:rows="server.statistics.commands"
				:columns="{
					command: {
						name: 'Command',
					},
					avg_3d: {
						name: '3-day avg.',
					},
					avg_4h: {
						name: '4-hour avg.',
					},
				}"
				:filters="{
					avg_3d: {
						name: '3-day avg.',
						mode: 'number',
					},
					avg_4h: {
						name: '4-hour avg.',
						mode: 'number',
					},
				}" />
		</div>

	</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    loading: false,
    records: [],
    active_tab: 'overview',
    threshold: 600
  }),
  watch: {
    active_tab () {
      if (this.active_tab.match(/^t\-/)) {
        console.log('update')
        for (var i in this.records) {
          if (!this.$refs['table-' + String(i)]) {
            continue
          }

          this.$refs['table-' + String(i)][0].setFilter({
            avg_3d: {
              mode: 'number',
              operator: '>',
              value: 6
            },
            avg_4h: {
              mode: 'number',
              operator: '>',
              value: 6
            }
          })
        }
      }
    }
  },
  computed: {
    ...mapGetters([]),
    dayList () {
      var list = []
      for (var d in this.records[0].statistics.times) {
        list.push(Number(d))
      }
      return list
    },
    tabs () {
      var list = {
        overview: {
          name: 'Overview'
        },
        't-0': {
          name: 'Master'
        }
      }

      for (var r in this.records) {
        const record = this.records[r]

        if (!record.worker) {
          continue
        }

        list['t-' + r] = {
          name: record.worker.name
        }
      }

      return list
    }
  },
  methods: {
    load () {
      Vue.$api.get('/cronjob-performance', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => this.parse(data)
      })
    },
    parse (data) {
      this.records = data
    }
  },
  created () {
    this.load()
  }
}
</script>
